import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { Button, Icon } from "semantic-ui-react";
import { ModalBuilder, Form, notifySuccess } from "@redriver/cinnamon";
import {
  addExpandedAgreementOrSchedule,
  getMasterAgreements,
  generateScheduleAndSheet,
  getAgreementScheduleSheets,
} from "features/Agreements/AgreementsList/actions";
import { getAgreementsState } from "features/Agreements/selectors";
import { SheetRoutes } from "constants/routes";
import { TranslatedModal } from "features/../../../shared/components/modals";

const AddSchedule = () => {
  const { t } = useTranslation("agreements");
  const dispatch = useDispatch();

  const { filters, companyFilters, pagination, agreements } =
    useSelector(getAgreementsState);

  const { dealer, dealerOffice, client } = companyFilters;

  const masterAgreementDropdownOptions =
    agreements?.map((x) => ({
      value: x.agreementId,
      text: x.agreementReference
        ? x.agreementReference + " - " + x.projectName
        : x.projectName,
    })) ?? [];

  return (
    <ModalBuilder
      submitAction={generateScheduleAndSheet}
      submitParams={{
        dealerOfficeId: dealerOffice ? dealerOffice.id : null,
        clientId: client ? client.id : null,
      }}
      onSubmitted={(param1, param2) => {
        const { scheduleId, sheetId } = param1;
        dispatch(addExpandedAgreementOrSchedule(scheduleId));
        dispatch(getMasterAgreements({ filters, pagination }, companyFilters));
        dispatch(getAgreementScheduleSheets(scheduleId, filters));
        dispatch(notifySuccess(t("Add_Schedule_Modal.CreatedSuccessfully")));
      }}
      withForm={true}
      renderTrigger={(showModal) => (
        <Button primary onClick={showModal} className="add-new-schedule">
          <Icon name="sticky note" size="large" />
          {t("Add_Schedule_Modal.Button")}
        </Button>
      )}
      renderModal={(modalProps, formProps) => (
        <TranslatedModal.Add
          {...modalProps}
          header={t("Add_Schedule_Modal.Title")}
          className="add-schedule-modal"
        >
          <Form {...formProps} className="new-schedule">
            <Form.Dropdown
              field="masterAgreementId"
              label={t("Add_Schedule_Modal.Master_Agreement")}
              placeholder="Master Agreement"
              required
              options={masterAgreementDropdownOptions}
              className="master-agreement-id"
            />

            <Form.Input
              field="projectName"
              label={t("Add_Schedule_Modal.Project_Name")}
              required
              className="new-project-name"
            />
          </Form>
        </TranslatedModal.Add>
      )}
    />
  );
};

export default AddSchedule;
